// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

/* eslint-disable check-file/filename-blocklist */
import type { MutationUpdaterFn } from 'apollo-client';
import type { DataProxy } from 'apollo-cache';
import { type FetchResult } from 'apollo-link';

import type {
	useReactionsDataContentQuery$data,
	useReactionsDataContentQuery$variables,
} from './hooks/__generated__/useReactionsDataContentQuery.graphql.ts';
import type {
	useReactionsDataCommentsQuery$data,
	useReactionsDataCommentsQuery$variables,
} from './hooks/__generated__/useReactionsDataCommentsQuery.graphql.ts';

type ContentReactionsSummaryRelay = NonNullable<
	NonNullable<
		NonNullable<NonNullable<useReactionsDataContentQuery$data['content']>['nodes']>[number]
	>['contentReactionsSummary']
>;
type CommentsReactionsSummaryRelay = NonNullable<
	NonNullable<
		NonNullable<NonNullable<useReactionsDataCommentsQuery$data['comments']>['nodes']>[number]
	>['reactionsSummary']
>;
import type { ReactionsDeleteReactionMutation as ReactionsDeleteReactionMutation$data } from './__types__/ReactionsDeleteReactionMutation.ts';
import type { ReactionsConfluenceSaveReactionMutation as ReactionsConfluenceSaveReactionMutation$data } from './__types__/ReactionsConfluenceSaveReactionMutation.ts';
export type {
	ContainerType as GQLContainerType,
	GraphQLReactionContentType as GQLContentType,
} from './__types__/ReactionsConfluenceSaveReactionMutation.ts';

export enum ReactionLocation {
	PAGE = 'page',
	BLOGPOST = 'blogpost',
	PAGE_COMMENT = 'page-comment',
	INLINE_COMMENT = 'inline-comment',
	EDITOR_INLINE_COMMENT = 'editor-inline-comment',
	FEED_PAGE = 'feed-page',
	FEED_BLOGPOST = 'feed-blogpost',
	FEED_COMMENT = 'feed-comment',
	OBJECT_COMMENT_FOOTER_PAGE = 'object-comment-footer-page',
	OBJECT_COMMENT_FOOTER_BLOGPOST = 'object-comment-footer-blogpost',
}

export enum ReactionContainerType {
	PAGE = 'page',
	BLOGPOST = 'blogpost',
	SPACE = 'space',
}

export type ReactionResponse = {
	ari: string;
	containerAri: string;
	emojiId: string;
};

export type Reaction = {
	ari: string; // cloudId
	containerAri: string; // contentId
	emojiId: string;
	count: number;
	reacted: boolean;
	users?: ReactedUser[];
	optimisticallyUpdated?: boolean;
};

export type ReactedUser = {
	id: string;
	displayName: string;
};

export type ReactionsData = ContentReactionsSummaryRelay | CommentsReactionsSummaryRelay | null;

export type QueryData = useReactionsDataContentQuery$data | useReactionsDataCommentsQuery$data;
export type QueryVariables =
	| useReactionsDataContentQuery$variables
	| useReactionsDataCommentsQuery$variables;

export type ReactedUsersMap = {
	[key: string]: ReactedUser[];
};

export type ReactionsMutationResultsData =
	| ReactionsConfluenceSaveReactionMutation$data
	| ReactionsDeleteReactionMutation$data;

export type ReactionsMutationResults = FetchResult<ReactionsMutationResultsData>;

export type ReactionMutationUpdateFn = (
	emojiId: string,
	actionType: 'add' | 'delete',
	contentId: string,
	containerId?: string,
	cache?: DataProxy,
	result?: ReactionsMutationResults,
	onCacheUpdateError?: (error: Error) => void,
) => MutationUpdaterFn<any> | void;
